export const useOrderActions = (text: any) => {
  const actions = [
    {
      key: "edit",
      label: text.all.edit,
    },
    {
      key: "add",
      label: text.all.add_parcels,
    },
    {
      key: "change",
      label: text.all.change_receiver,
    },
    {
      key: "delete",
      label: text.all.delete,
    },
  ];

  return actions;
};
export const useParcelActions = (text: any) => {
  const actions = [
    {
      key: "edit",
      label: text.all.edit,
    },
    {
      key: "delete",
      label: text.all.delete,
    },
  ];

  return actions;
};
